import { connect } from "react-redux";
import isArray from "lodash.isarray";
import {
  selectWIClaimantData,
  selectCurrentWIFees,
  selectCurrentWorkItemStateName
} from "selector/initializeSelector";
import Summary from "components/summary/Summary";
import { cancelWorkItemAction } from "actions/questionaireActions";
import { history } from "store";
import { getWorkItemType } from "utils";

export const mapStateToProps = state => {
  const workItem = state.workItems.currentWorkItem;
  const workItemId = workItem && workItem.workItemId;
  const displayError = state.workItems.currentWorkItem.messages && state.workItems.currentWorkItem.messages.filter(a => a.key === "BadRequest" || a.key == "400").length > 0;
  const dummyVin = workItem.preferences?.attributes?.DummyVin
  let errorMessage = displayError ? state.workItems.currentWorkItem.messages.filter(a => a => a.key === "BadRequest")[0].messageText : "";
  errorMessage = errorMessage.replace("Samba Response.", "California registration system.<br/><br/>")
  if(errorMessage.includes("Fees not found")){
    errorMessage = errorMessage;
  }else if (errorMessage.includes("code 1100")){
    errorMessage = errorMessage.replace(" with error code 1100","");
  } else if(errorMessage.includes("code 5000")){
    errorMessage = errorMessage.replace(" with info code 5000","");
  } else if(errorMessage.includes("code 1003")){
    errorMessage = errorMessage.replace(" with error code 1003","");
  } else if(errorMessage.includes("code 902")){
    errorMessage = errorMessage.replace(" with error code 902","");
  } else if(errorMessage.includes("code 5002")){
    errorMessage = errorMessage.replace(" with info code 5002","");
  } else if(errorMessage.includes("code 2101")){
    errorMessage = errorMessage.replace(" with warning code 2101","");
  } else {
    errorMessage = "We apologize for any inconvenience, but your request was not able to be processed at this time.<br/><br/> Please contact an Autosource Account Representative at 800 351 3133 and select option 5";
  }
  const fees = selectCurrentWIFees(state);
  const isDual = isArray(fees);
  if (!workItemId) {
    return { data: {} };
  }
  if (!fees) {    
    return {
      data: {
        fees: null,
        totalPayment: "0.00",
        totalRefunded: "0.00",
        claimantData: selectWIClaimantData(state),
        salesTaxData: null,
        workItemId: workItemId,
        isDual: false,
        type: null,
        displayError: displayError,
        errorMessage: errorMessage, 
        dummyVin: dummyVin
      }
    };
  }
  return {
    data: {
      isDual,
      fees: fees,
      type: isDual ? "dual" : getWorkItemType(workItem),
      claimantData: selectWIClaimantData(state),
      salesTaxData: state.workItems.currentWorkItem.taxes,
      workItemId: workItemId,
      state: selectCurrentWorkItemStateName(state),
      displayError: displayError,
      errorMessage: errorMessage,
      dummyVin: dummyVin
    }
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onCancel: (...args) => dispatch(cancelWorkItemAction(...args)),
    onGeneratePDF: ({ workItemId, isDual, type }) =>
      history.push(`/report/${workItemId}`, { isDual, type })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Summary);
